
import { Link } from "react-router-dom";
import { getRelatedPosts } from "@/data/blogPosts";
import type { BlogPost } from "@/data/blogPosts";

interface RelatedBlogsProps {
  currentPostId: number;
  limit?: number;
}

export const RelatedBlogs = ({ currentPostId, limit = 3 }: RelatedBlogsProps) => {
  const relatedPosts = getRelatedPosts(currentPostId, limit);
  
  if (relatedPosts.length === 0) return null;
  
  return (
    <div className="mt-12 pt-8 border-t border-gray-200">
      <h3 className="text-2xl font-serif font-medium mb-6">Related Articles</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {relatedPosts.map((post) => (
          <Link 
            to={`/blog/${post.slug}`} 
            key={post.id}
            className="group block p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300"
          >
            <h4 className="font-serif text-lg font-medium group-hover:text-dental-highlight transition-colors">
              {post.title}
            </h4>
            <p className="text-dental-muted text-sm mt-2 line-clamp-2">{post.excerpt}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};
